import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Use redux-persist's default storage
import { persistReducer } from "redux-persist";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist/es/constants";

import authReducer from "./actions/authSlice";
import pageTitleReducer from "./actions/pageTitleSlice";
import snackbarReducer from "./actions/snackbarSlice";
import alertsSlice from "./actions/alertsSlice";
import cashierSlice from "./actions/cashierSlice";
import driversSlice from "./actions/driversSlice";
import ordersSlice, { cancelledOrdersTransform } from "./actions/ordersSlice";
import merchantsSlice from "./actions/merchantsSlice";
import dashboardSlice, { dashboardTransform } from "./actions/dashboardSlice";
import saloonTablesSlice from "./actions/saloonTablesSlice";
import deliveryCenterSlice from "./actions/deliveryCenterSlice";
import mapSlice from "./actions/mapSlice";
import shippingRoutesSlice from "./actions/shippingRoutesSlice";
import smartRoutingSlice from "./actions/smartRoutingSlice";
import operationDataSlice from "./actions/operationDataSlice";
import orderQueueReducer from "./actions/orderQueueSlice";
import newOrderSlice from "./actions/newOrderSlice";
import onboardingReducer from "./actions/onboardingSlice";

import {
  fetchOrderDetailsMiddleware,
  listenerMiddleware,
  orderQueueMiddleware,
} from "./middlewares/orders";

// Configure redux-persist
const persistConfig = {
  key: "LastMileSlapie",
  storage,
  whitelist: ["auth", "pageTitle", "orderQueue", "deliveryCenter", "dashboard"],
  transforms: [dashboardTransform, cancelledOrdersTransform],
};

// Wrap your rootReducer with persistReducer
const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authReducer,
    pageTitle: pageTitleReducer,
    snackbar: snackbarReducer,
    deliveryCenter: deliveryCenterSlice,
    dashboard: dashboardSlice,
    saloonTables: saloonTablesSlice,
    map: mapSlice,
    shippingRoutes: shippingRoutesSlice,
    smartRouting: smartRoutingSlice,
    alerts: alertsSlice,
    cashier: cashierSlice,
    drivers: driversSlice,
    orders: ordersSlice,
    merchants: merchantsSlice,
    operationData: operationDataSlice,
    orderQueue: orderQueueReducer,
    newOrder: newOrderSlice,
    onboarding: onboardingReducer,
  })
);

// Create the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: { warnAfter: 128 },
    }).concat([
      fetchOrderDetailsMiddleware,
      orderQueueMiddleware,
      listenerMiddleware.middleware,
    ]),
});

export default store;
